// extracted by mini-css-extract-plugin
export default {"slider":"HomePage_slider__5QAEY","slideTrack":"HomePage_slideTrack__3tPeS","scroll":"HomePage_scroll__Pn6PM","slide":"HomePage_slide__Sv2ae"};